module.exports = __webpack_public_path__ + "static/manuel_cantueso-b8b592ce3bdbd0b410db4b4751a89828.jpg";